// extracted by mini-css-extract-plugin
export default {"Container":"Pricing_Container__U3Gff","Pricing":"Pricing_Pricing__gRV7L"};